<!--card no-margin-->
<div class="ui-g-12">
    <div class="ui-g-12">

        <label style="margin:2px ; margin-right: 80px; vertical-align: super;"><b>Choose a Patient : </b></label>
        <p-dropdown class="notranslate" id="patient" [options]="members_list" placeholder="Select" optionLabel="label"
            [(ngModel)]="selectedMember" (ngModelChange)="getDiscountList($event.value)"
            [disabled]="this.member_api_result.Posting || this.coupon_api_result.Posting">
        </p-dropdown>


        <div class="ui-g">
            <div class="ui-g-12">
                <h1 class="text-align-center">Coupon Codes</h1>

                <div class="ui-g">
                    <div class="ui-g-12">
                        <div class="apply-info">
                            <p class="heading3 egd-theme-text">How to apply coupon?</p>
                            <p class="heading4">
                                <i id="iconStyle" class="fa fa-info-circle " aria-hidden="true">&nbsp;&nbsp;</i>
                                Click on apply button or enter the code you have in the apply coupon code section at the
                                payment
                                screen to get the benefits of discount code .
                            </p>
                        </div>

                    </div>
                    <div class="ui-g-12">
                        <div class="ui-g">
                            <div class="ui-g-12 three-d-card coupon-code-card" *ngFor="let code of DiscountCodeList">
                                <div class="ui-g-12 ui-md-3">
                                    <p class="coupon-head heading3 egd-theme-text font-weight-bold text-align-center">
                                        {{code.referral_type}}
                                    </p>
                                </div>
                                <div class="ui-g-12 ui-md-6">
                                    <p class="coupon-discription heading4 text-align-center">
                                        Use Code {{code.discount_code}} To Get
                                        <b class="egd-theme-text">{{code.discount_percent}}%</b>
                                        Off On Your Checkout Price
                                    </p>
                                </div>
                                <div class="ui-g-12 ui-md-3">
                                    <p class="coupon-code heading3 egd-theme-text font-weight-bold text-align-center">
                                        {{code.discount_code}}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ui-g-12">
                    <app-error-messages [api_result]="this.member_api_result">
                    </app-error-messages>
                    <app-error-messages [api_result]="this.coupon_api_result">
                    </app-error-messages>
                </div>
                <div class="ui-g-12 text-center">
                    <app-loading *ngIf="this.member_api_result.Posting || this.coupon_api_result.Posting"
                        type="LOADING_DATA"></app-loading>
                </div>
            </div>
        </div>


    </div>